import { defineFcm } from '../shared/factory';

export const FCM_EXPORT_SERVICE = defineFcm('export_service')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: ['corgi-middle-end', 'export-service'],
		context: 'Signature export',
		description: 'Used to disable signature export capability in case of maintenance',
	});
